import { styled } from '@mui/material/styles';

export const CarouselContainer = styled('div', {
    name: 'Carousel',
    slot: 'container',
    skipSx: false,
})({
    display: 'flex',
    touchAction: 'pan-y pinch-zoom',
});
